import { KeycloakAction, KeycloakContextActionTypes, IKeycloakProviderState, AuthClient } from './types';
import { defaultKeycloakProviderState } from './defaultState';

const KeycloakReducer = (
  state: IKeycloakProviderState<AuthClient>,
  action: KeycloakAction<AuthClient>,
): IKeycloakProviderState<AuthClient> => {
  if (!state.authClient) {
    return state;
  }
  switch (action.type) {
    case KeycloakContextActionTypes.Init:
      const {
        onReady,
        onAuthSuccess,
        onAuthError,
        onAuthRefreshSuccess,
        onAuthRefreshError,
        onAuthLogout,
        onTokenExpired,
        ...rest
      } = action.payload;
      return {
        ...state,
        authClient: {
          ...action.payload,
          ...state.authClient,
          onReady,
          onAuthSuccess,
          onAuthError,
          onAuthRefreshSuccess,
          onAuthRefreshError,
          onAuthLogout,
          onTokenExpired,
          ...rest,
        },
        isAuthenticated: false,
        isLoading: true,
        initialized: false,
      };

    case KeycloakContextActionTypes.SetTokens:
      // Do not update grant tokens if session is not expired
      if (state.authClient.token === action.payload.token) {
        return state;
      }
      return {
        ...state,
        authClient: {
          ...state.authClient,
          token: action.payload.token,
          idToken: action.payload.idToken,
          tokenParsed: action.payload.tokenParsed,
          refreshToken: action.payload.refreshToken,
        },
      };

    case KeycloakContextActionTypes.SetAuthStatus:
      // Do not update authenticated status if the user remains logged in
      if (state.isAuthenticated === action.payload) {
        return state;
      }
      return {
        ...state,
        isAuthenticated: action.payload.isAuthenticated,
        initialized: action.payload.initialized,
        isLoading: action.payload.isLoading,
      };

    case KeycloakContextActionTypes.ClearTokens:
      return defaultKeycloakProviderState;

    case KeycloakContextActionTypes.Reset:
      return {
        ...state,
        isLoading: true,
        initialized: false,
        isAuthenticated: false,
      };

    case KeycloakContextActionTypes.SetSelectedCustomerId:
      return {
        ...state,
        selectedCustomerId: action.payload,
      };

    default: {
      return state;
    }
  }
};

export { KeycloakReducer };
